// Very, very basic mobile detection.
export const isMobile = () => {
  return window.innerWidth <= 800;
};
